import { gql } from '@apollo/client';

export const CAPTURE_HEAP_SNAPSHOT = gql(/* GraphQL */ `
    mutation CaptureHeapSnapshot {
        captureHeapSnapshot {
            uploaded
            key
            error
        }
    }
`);
